module.exports = __webpack_public_path__ + "img/lion-40.81ca375f.png";